<script setup>
  defineProps({ fighter: Object, small: Boolean });
</script>

<!----------------------------------------------------------------------------->

<template>
  <span class="flags" :class="{ small }">
    <img
      v-if="fighter.fighter.nationality"
      v-for="country in fighter.fighter.nationality"
      width="32"
      height="24"
      :src="useCdn().generateFlag(country.key.toLowerCase())"
    />
  </span>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  .flags {
    display: flex;
    gap: px(16);

    flex-shrink: 0;

    &.small {
      img {
        width: px(16);
      }
    }
  }
</style>
